import { useLanguage } from '@/i18n/LanguageContext';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const BrandStatement = () => {
  const { t } = useLanguage();
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-16 md:py-24 lg:py-32 px-6" aria-labelledby="brand-statement-heading">
      <div 
        ref={ref}
        className={`max-w-6xl mx-auto ${isVisible ? '' : ''}`}
      >
        {/* Bronze line separator */}
        <div 
          className={`w-20 h-px bg-gold mb-16 transition-transform duration-700 origin-left ${isVisible ? 'scale-x-100' : 'scale-x-0'}`}
          aria-hidden="true" 
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20">
          {/* Left: Headline */}
          <div className={`reveal-on-scroll ${isVisible ? 'revealed' : ''}`}>
            <h2 
              id="brand-statement-heading"
              className="font-serif text-2xl sm:text-3xl lg:text-5xl text-foreground leading-tight"
            >
              {t.brandStatementHeadline}
            </h2>
          </div>

          {/* Right: Philosophy text */}
          <div className={`reveal-on-scroll reveal-on-scroll-delay-1 ${isVisible ? 'revealed' : ''}`}>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-6">
              {t.brandStatementText}
            </p>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              {t.brandStatementText2}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandStatement;
